const generate = (prefix, ui = false) => (ui ? {
  REQUEST_UPDATE: `${prefix}_REQUEST_UPDATE`,
  SUCCESS: `${prefix}_SUCCESS`,
  FAILURE: `${prefix}_FAILURE`,
} : {
  FETCHING: `${prefix}_FETCHING`,
  SUCCESS: `${prefix}_SUCCESS`,
  FAILURE: `${prefix}_FAILURE`,
  CLEAR: `${prefix}_CLEAR`,
});

/* Auth */
export const AUTH_FORGET_PASSWORD = generate('AUTH_FORGET_PASSWORD');
export const AUTH_LOGIN = generate('AUTH_LOGIN');
export const AUTH_REGISTER = generate('AUTH_REGISTER');
export const AUTH_RESEND_VERIFICATION_TOKEN = generate('AUTH_RESEND_VERIFICATION_TOKEN');
export const AUTH_RESET_PASSWORD = generate('AUTH_RESET_PASSWORD');
export const AUTH_VERIFY = generate('AUTH_VERIFY');
export const AUTH_VERIFY_FORGET_PASSWORD_TOKEN = generate('AUTH_VERIFY_FORGET_PASSWORD_TOKEN');

/* Options */
export const READ_OPTIONS_FINANCIAL_YEAR = generate('READ_OPTIONS_FINANCIAL_YEAR');
export const READ_OPTIONS_FUND = generate('READ_OPTIONS_FUND');
export const READ_OPTIONS_GIVING = generate('READ_OPTIONS_GIVING');
export const READ_OPTIONS_RECEIPT = generate('READ_OPTIONS_RECEIPT');
export const READ_OPTIONS_PAYMENT_METHOD = generate('READ_OPTIONS_PAYMENT_METHOD');
export const READ_OPTIONS_SERVICE = generate('READ_OPTIONS_SERVICE');
export const READ_OPTIONS_AUTH_REGISTER = generate('READ_OPTIONS_AUTH_REGISTER');
export const READ_OPTIONS_PUBLIC_FINANCIAL_YEAR = generate('READ_OPTIONS_PUBLIC_FINANCIAL_YEAR');
export const READ_OPTIONS_PUBLIC_FUND = generate('READ_OPTIONS_PUBLIC_FUND');
export const READ_OPTIONS_PUBLIC_GIVING = generate('READ_OPTIONS_PUBLIC_GIVING');
export const READ_OPTIONS_PUBLIC_PAYMENT_METHOD = generate('READ_OPTIONS_PUBLIC_PAYMENT_METHOD');
export const READ_OPTIONS_PUBLIC_SERVICE = generate('READ_OPTIONS_PUBLIC_SERVICE');

/* Public */
export const CREATE_PUBLIC_GIVING = generate('CREATE_PUBLIC_GIVING');
export const READ_PUBLIC_GIVING = generate('READ_PUBLIC_GIVING');
export const READ_PUBLIC_GIVINGS = generate('READ_PUBLIC_GIVINGS');
export const UPDATE_PUBLIC_GIVING = generate('UPDATE_PUBLIC_GIVING');
export const DELETE_PUBLIC_GIVING = generate('DELETE_PUBLIC_GIVING');

/* Giver */
export const READ_CURRENT = generate('READ_CURRENT');
export const UPDATE_CURRENT = generate('UPDATE_CURRENT');

export const READ_GIVINGS_STATISTICS = generate('READ_GIVINGS_STATISTICS');
export const CREATE_GIVING = generate('CREATE_GIVING');
export const READ_GIVING = generate('READ_GIVING');
export const READ_GIVINGS = generate('READ_GIVINGS');
export const UPDATE_RECURRING_GIVING = generate('UPDATE_RECURRING_GIVING');
export const UPDATE_GIVING = generate('UPDATE_GIVING');
export const DELETE_GIVING = generate('DELETE_GIVING');

export const CREATE_PRODUCT = generate('CREATE_PRODUCT');
export const READ_PRODUCT = generate('READ_PRODUCT');
export const READ_PRODUCTS = generate('READ_PRODUCTS');
export const UPDATE_PRODUCT = generate('UPDATE_PRODUCT');
export const DELETE_PRODUCT = generate('DELETE_PRODUCT');

export const CREATE_RECEIPT = generate('CREATE_RECEIPT');
export const READ_RECEIPT = generate('READ_RECEIPT');
export const READ_RECEIPTS = generate('READ_RECEIPTS');
export const UPDATE_RECEIPT = generate('UPDATE_RECEIPT');
export const DELETE_RECEIPT = generate('DELETE_RECEIPT');

export const CREATE_SUBSCRIPTION = generate('CREATE_SUBSCRIPTION');
export const READ_SUBSCRIPTION = generate('READ_SUBSCRIPTION');
export const READ_SUBSCRIPTIONS = generate('READ_SUBSCRIPTIONS');
export const UPDATE_SUBSCRIPTION = generate('UPDATE_SUBSCRIPTION');
export const DELETE_SUBSCRIPTION = generate('DELETE_SUBSCRIPTION');
export const CANCEL_SUBSCRIPTION = generate('CANCEL_SUBSCRIPTION');

/* Errors */
export const RESET_ERRORS = generate('RESET_ERRORS', true);
